import styled from '@emotion/styled';
import { Box } from '@opendoor/bricks-next';
import Script from 'next/script';

import type { EntryComponent } from '../../cms/entries/entries';
import type { IComponentTwitter } from '../../declarations/contentful';

const TweetAnchor = styled.a`
  color: transparent;
`;

//https://platform.twitter.com/widgets.js

const RenderTwitterTweet = (entry: IComponentTwitter) => {
  const { fields } = entry;

  return (
    <>
      <Script src="https://platform.twitter.com/widgets.js" strategy="lazyOnload" />
      <Box
        className="embedded-entry-wrapper"
        display="flex"
        justifyContent="center"
        $platform-web={{ gridColumn: '5 / -2' }}
      >
        {/* eslint-disable @opendoor/no-html-elements */}
        <blockquote className="twitter-tweet">
          <TweetAnchor href={'https://twitter.com/x/status/' + fields.tweetId}>
            Tweet Link
          </TweetAnchor>
        </blockquote>
        {/* eslint-enable @opendoor/no-html-elements */}
      </Box>
    </>
  );
};

const TwitterTweet: EntryComponent<IComponentTwitter> = {
  render: RenderTwitterTweet,
};

export default TwitterTweet;
